import React from 'react';
import ArrowIcon2 from '../../icons/ArrowIcon2';
import cx from 'classix';

interface ScrollToBottomProps {
    onClick: () => void;
    visible: boolean;
}

export const ScrollToBottom: React.FC<ScrollToBottomProps> = ({ onClick, visible }) => {
    return (
        <div 
            onClick={onClick}
            className={cx(
                "top-[calc(100%-1rem)] inset-x-0 sticky hover:text-white flex justify-start transition-all duration-300 ease-in-out z-10",
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
            )}
        >
            <div className="border-2 border-gray-100 shadow-sm shadow-black/20 rounded-full bg-white cursor-pointer p-2">
                <ArrowIcon2 className={'size-4 stroke-accent rotate-90'} />
            </div>
        </div>
    );
};
